function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { extends as _extends } from "../_virtual/_rollupPluginBabelHelpers.js";
import { createContext, useRef, useState } from 'react';
import { jsx } from '@emotion/core';
import useStores from "../hooks/useStores.js";
import DrawableField from "../components/annotation/drawable/DrawableField.js";
import FillableField from "../components/annotation/fillable/FillableField.js";
var AnnotationLayerContext =
/*#__PURE__*/
createContext(null);

var getRelativeMouseLocation = function getRelativeMouseLocation(_ref, pageAnnotationLayer) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;

  var _pageAnnotationLayer$ = pageAnnotationLayer.getBoundingClientRect(),
      left = _pageAnnotationLayer$.left,
      top = _pageAnnotationLayer$.top;

  return {
    x: clientX - left,
    y: clientY - top
  };
};

function Drawable(_ref2) {
  var children = _ref2.children;
  var currentPageStoreRef = useRef(null);
  var mouseStartRef = useRef(null);
  var pageAnnotationLayerRef = useRef(null);
  var selectedFieldOriginalLocAndDimsRef = useRef(null);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      cursorMode = _useState2[0],
      setCursorMode = _useState2[1];

  var clickTypeRef = useRef(null);

  var handleMouseDown = function handleMouseDown(_ref3, pageAnnotationLayer, pageStore) {
    var nativeEvent = _ref3.nativeEvent;
    var currentMouse = getRelativeMouseLocation(nativeEvent, pageAnnotationLayer);
    var clickType = nativeEvent.button === 2 ? 'right' : 'left';
    var selectedField = pageStore.pdfStore.selectedField;
    var fieldClick = selectedField === null || selectedField === void 0 ? void 0 : selectedField.containsPoint({
      x: pageStore.unScale(currentMouse.x),
      y: pageStore.unScale(currentMouse.y)
    });
    var resizeClick = /resize-handle/.test(nativeEvent.target.classList.value);

    if (clickType === 'right') {
      pageStore.pdfStore.setContextMenu({
        position: {
          x: currentMouse.x,
          y: currentMouse.y
        },
        onField: !!fieldClick,
        page: pageStore.pageNumber
      });
    } else {
      if (selectedField && fieldClick) {
        pageStore.moveFieldToFront(selectedField);
        selectedFieldOriginalLocAndDimsRef.current = {
          x: selectedField.x,
          y: selectedField.y,
          width: selectedField.width,
          height: selectedField.height
        };

        if (resizeClick) {
          setCursorMode('nwse-resize');
          pageStore.pdfStore.setResizingField(selectedField);
        } else {
          setCursorMode('grabbing');
          pageStore.pdfStore.setDraggingField(selectedField);
        }
      } else if (!pageStore.pdfStore.contextMenu) {
        pageStore.drawField(currentMouse);
      }

      pageStore.pdfStore.setContextMenu();
    }

    currentPageStoreRef.current = pageStore;
    mouseStartRef.current = currentMouse;
    pageAnnotationLayerRef.current = pageAnnotationLayer;
    clickTypeRef.current = clickType;
    nativeEvent.preventDefault();
    nativeEvent.stopPropagation();
  };

  var handleMouseMove = function handleMouseMove(_ref4) {
    var nativeEvent = _ref4.nativeEvent;

    if (mouseStartRef.current && currentPageStoreRef.current && pageAnnotationLayerRef.current && clickTypeRef.current === 'left') {
      var currentMouse = getRelativeMouseLocation(nativeEvent, pageAnnotationLayerRef.current);
      var currentPageStore = currentPageStoreRef.current;
      var mouseStart = mouseStartRef.current;

      if (selectedFieldOriginalLocAndDimsRef.current) {
        var _selectedFieldOrigina = selectedFieldOriginalLocAndDimsRef.current,
            x = _selectedFieldOrigina.x,
            y = _selectedFieldOrigina.y,
            width = _selectedFieldOrigina.width,
            height = _selectedFieldOrigina.height;

        if (currentPageStore.pdfStore.draggingField) {
          currentPageStore.updateDraggingFieldLocation({
            x: x,
            y: y
          }, mouseStart, currentMouse);
        } else {
          currentPageStore.updateResizingFieldDimensions({
            x: x,
            y: y,
            width: width,
            height: height
          }, mouseStart, currentMouse);
        }
      }
    }

    nativeEvent.preventDefault();
    nativeEvent.stopPropagation();
  };

  var handleMouseUp = function handleMouseUp(_ref5) {
    var _currentPageStoreRef$, _currentPageStoreRef$2;

    var nativeEvent = _ref5.nativeEvent;
    (_currentPageStoreRef$ = currentPageStoreRef.current) === null || _currentPageStoreRef$ === void 0 ? void 0 : _currentPageStoreRef$.pdfStore.setDraggingField();
    (_currentPageStoreRef$2 = currentPageStoreRef.current) === null || _currentPageStoreRef$2 === void 0 ? void 0 : _currentPageStoreRef$2.pdfStore.setResizingField();
    currentPageStoreRef.current = null;
    mouseStartRef.current = null;
    pageAnnotationLayerRef.current = null;
    selectedFieldOriginalLocAndDimsRef.current = null;
    clickTypeRef.current = null;
    setCursorMode(undefined);
    nativeEvent.preventDefault();
    nativeEvent.stopPropagation();
  };

  return jsx(AnnotationLayerContext.Provider, {
    value: {
      Field: DrawableField,
      cursorMode: cursorMode,
      handleMouseDown: handleMouseDown,
      handleMouseMove: handleMouseMove,
      handleMouseUp: handleMouseUp
    }
  }, children);
}

Drawable.displayName = "Drawable";

function Fillable(_ref6) {
  var children = _ref6.children,
      viewOnly = _ref6.viewOnly,
      signingDisabled = _ref6.signingDisabled,
      reassigningFieldsEnabled = _ref6.reassigningFieldsEnabled;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  return jsx(AnnotationLayerContext.Provider, {
    value: {
      Field: function Field(props) {
        return jsx(FillableField, _extends({}, props, {
          disabled: viewOnly,
          signingDisabled: signingDisabled,
          reassigningFieldsEnabled: reassigningFieldsEnabled
        }));
      },
      handleClick: function handleClick() {
        return pdfStore.setSelectedField();
      }
    }
  }, children);
}

Fillable.displayName = "Fillable";
export default AnnotationLayerContext;
export { Drawable, Fillable };